import {
  GET_STATUSSAMPLE,
  GET_STATUSSAMPLE_FAIL,
  GET_STATUSSAMPLE_SUCCESS,
  GET_STATUSSAMPLES,
  GET_STATUSSAMPLES_FAIL,
  GET_STATUSSAMPLES_SUCCESS,
  ADD_NEW_STATUSSAMPLE,
  ADD_STATUSSAMPLE_SUCCESS,
  ADD_STATUSSAMPLE_FAIL,
  UPDATE_STATUSSAMPLE,
  UPDATE_STATUSSAMPLE_SUCCESS,
  UPDATE_STATUSSAMPLE_FAIL,
  DELETE_STATUSSAMPLE,
  DELETE_STATUSSAMPLE_SUCCESS,
  DELETE_STATUSSAMPLE_FAIL,
  SET_STATE_STATUSSAMPLE,
  UPDATE_STATUSSAMPLE_STATUS
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_STATUSSAMPLE,
  payload: loading,
})

export const getStatusSamples = ( params ) => ({
  type: GET_STATUSSAMPLES,
  payload: { params },
})

export const getStatusSamplesSuccess = (statusSamples, totalPages, currentPage) => ({
  type: GET_STATUSSAMPLES_SUCCESS,
  payload: { statusSamples:statusSamples, total:totalPages, currentPage:currentPage}
})

export const getStatusSamplesFail = error => ({
  type: GET_STATUSSAMPLES_FAIL,
  payload: error,
})

export const addNewStatusSample = statusSample => ({
  type: ADD_NEW_STATUSSAMPLE,
  payload: statusSample,
})

export const addStatusSampleSuccess = statusSample => ({
  type: ADD_STATUSSAMPLE_SUCCESS,
  payload: statusSample,
})  

export const addStatusSampleFail = error => ({
  type: ADD_STATUSSAMPLE_FAIL,
  payload: error,
})

export const updateStatusSample = statusSample => ({
  type: UPDATE_STATUSSAMPLE,
  payload: statusSample,
})

export const updateStatusSampleStatus = statusSample => ({
  type: UPDATE_STATUSSAMPLE_STATUS,
  payload: statusSample,
})

export const updateStatusSampleSuccess = statusSample => ({
  type: UPDATE_STATUSSAMPLE_SUCCESS,
  payload: statusSample,
})

export const updateStatusSampleFail = error => ({
  type: UPDATE_STATUSSAMPLE_FAIL,
  payload: error,
})

export const deleteStatusSample = statusSample => ({
  type: DELETE_STATUSSAMPLE,
  payload: statusSample,
})

export const deleteStatusSampleSuccess = id => ({
  type: DELETE_STATUSSAMPLE_SUCCESS,
  id,
})

export const deleteStatusSampleFail = error => ({
  type: DELETE_STATUSSAMPLE_FAIL,
  payload: error,
})

export const getStatusSample = () => ({
  type: GET_STATUSSAMPLE,
})

export const getStatusSampleSuccess = statusSample => ({
  type: GET_STATUSSAMPLE_SUCCESS,
  payload: statusSample,
})

export const getStatusSampleFail = error => ({
  type: GET_STATUSSAMPLE_FAIL,
  payload: error,
})
